import _ from 'lodash';
import { adapi, moment } from '~';
import { mapState, mapActions } from 'vuex';
import BoxWidget from '@/components/box-widget/BoxWidget.vue';
import { EVENT_TYPES, EVENT_TYPES_HISTORY } from '@/util/constants';

export default {
  data() {
    return {
      loading: false,
    };
  },
  components: {
    'box-widget': BoxWidget,
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('creative', {
      creative: 'current',
    }),
    operator() {
      return _.get(this.creative, 'operator', null);
    },
    lastAssigment() {
      return _.get(this.creative, 'timeline', [])
              .find(event => event.type === EVENT_TYPES.HISTORY
                              && event.data.type === EVENT_TYPES_HISTORY.OPERATOR_CHANGE);
    },
    assigned() {
      return _.get(this.lastAssigment, 'data.to_user', null);
    },
    unassigned() {
      return _.get(this.lastAssigment, 'data.from_user', null);
    },
    canUpdateAssigner() {
      return _.get(this.creative, '_meta.permissions', []).includes('assign');
    },
  },
  methods: {
    ...mapActions('creative', ['setCurrentCreative']),
    assign() {
      const userId = this.operator ? 0 : this.user.id;

      this.loading = true;
      return adapi.post(`creatives/${this.creative.id}/assign`, null, { user_id: userId })
        .then(result => {
          this.setCurrentCreative(result);
          const message = userId === 0 ? 'unassigned' : 'assigned';
          this.$toast.success({ message: this.$t(`pos.creative.operator-${message}`) });
          this.loading = false;
        })
        .catch(e => {
          this.$toast.error({ message: e.toString() });
          this.loading = false;
        });
    },
    getTimeAgo(timestamp) {
      return moment(timestamp).fromNow();
    },
    getFullDate(timestamp) {
      return this.$t('fn.datetime', { timestamp });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/assignees-info/AssigneesInfo.js